import { useEffect, useRef, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

export function PersonRegistrationDialog({ title, busy, onClose, children }: {
  title: string; busy: boolean; onClose: () => void; children: ReactNode
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const element = dialog.current
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null
    const overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    element?.showModal()
    return () => {
      element?.close()
      document.body.style.overflow = overflow
      previous?.focus()
    }
  }, [])
  return createPortal(<dialog ref={dialog} className="person-registration-dialog" aria-label={title} onCancel={event => { event.preventDefault(); if (!busy) onClose() }}>
    <div className="person-registration-dialog-toolbar"><h2>{title}</h2><button type="button" disabled={busy} onClick={onClose} aria-label="Fechar cadastro">Fechar ×</button></div>
    {children}
  </dialog>, document.body)
}
